@if (show() || closing()) {
  <div
    class="flex items-start gap-3 w-sm p-4 rounded-xl border border-border shadow-lg pointer-events-auto relative"
    [class.animate-fade-in]="!closing()"
    [class.animate-fade-out]="closing()"
    (animationend)="closing() ? onFadeOutDone() : null"
    role="alert"
    [ngClass]="[getTypeClass(), getBgClass()]"
  >
    <app-icon
      [name]="getIcon()"
      [size]="20"
      class="shrink-0 mt-0.5"
      aria-hidden="true"
    />
    <div class="flex-1">
      @if (title()) {
        <p class="font-semibold text-sm">{{ title() }}</p>
      }
      <span class="text-sm">{{ message() }}</span>
    </div>
    <button
      (click)="close()"
      aria-label="Fermer la notification"
      class="bg-transparent cursor-pointer"
    >
      <app-icon name="x" [size]="16" aria-hidden="true" />
    </button>
  </div>
}
